if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register(new URL('./service-worker.js', import.meta.url));
            console.log('ServiceWorker registration successful with scope: ', registration.scope);
        } catch (error) {
            console.log('ServiceWorker registration failed: ', error);
        }
    });
}

const styleJson = `https://api.maptiler.com/maps/23fc4bc6-8298-4acd-bf38-b54a2bedc7ea/style.json?key=tCm4ufit3cvrDyoH811u`;
const attribution = new ol.control.Attribution({
    collapsible: true,
});

async function loadGeoJSON(olms) {
    try {

        const tooltip = document.getElementById('tooltip_custom');
        const response = await fetch(new URL('./data/latigra.geojson', import.meta.url));

        const geojsonObject = await response.json();

        // Create a vector source from the GeoJSON object
        const vectorSource = new ol.source.Vector({
            features: new ol.format.GeoJSON().readFeatures(geojsonObject, {
                featureProjection: 'EPSG:3857' // This is the default projection used by OpenLayers
            })
        });


        // Create vector layers for suppliers and warehouses
        const supplierLayer = new ol.layer.Vector({
            source: new ol.source.Vector({
                features: vectorSource.getFeatures().filter(feature => feature.id_ === 'U2MDY1')
            }),
            style: styleFunction1,
            zIndex: 10 // Ensure the vector layer is on top
        });

 
        // Create a vector layer to display the features
        const vectorLayer = new ol.layer.Vector({
            source: vectorSource,
            style: styleFunction,
            zIndex: 10
        });


        // Create a map and add the vector layer to it
        const map = new ol.Map({
            target: 'map',
            controls: ol.control.defaults.defaults({ attribution: false }).extend([attribution]),
            layers: [
                new ol.layer.Tile({
                    source: new ol.source.OSM()
                }),
                vectorLayer,
                supplierLayer

            ],
            view: new ol.View({
                constrainResolution: true,
                center: ol.proj.fromLonLat([ -84.577414, 10.343776]), // Centered on the US
                zoom: 17
            })
        });


        const showTooltip =  (evt)  => {
            tooltip.style.display = 'none';  // Hide tooltip by default

            // Detect feature at the cursor
            map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                const featureName = feature.get('name');  // Get the 'name' property
                
                if (featureName && featureName != 'perimeter' ) {
                    tooltip.innerHTML = featureName;  // Set tooltip text
                    tooltip.style.display = 'block';  // Display tooltip
                    tooltip.style.left = `${evt.pixel[0] + 10}px`;  // Position tooltip with offset
                    tooltip.style.top = `${evt.pixel[1] + 10}px`;
                }
            });
        }
        map.on('pointermove', showTooltip);  // Desktop hover
        map.on('pointerdown', showTooltip);  // Mobile tap
        map.on('touchstart', showTooltip);   // Mobile touch


        // Optional: Hide tooltip when the mouse leaves the map
        map.getViewport().addEventListener('mouseout', () => {
           // tooltip.style.display = 'none';
        });

        // add style
       // olms.apply(map);
    } catch (error) {
        console.error('Error loading the GeoJSON file:', error);
    }
}

loadGeoJSON(olms)


// Function to apply styles based on feature properties
const styleFunction = feature => {
    return new ol.style.Style({
        fill: new ol.style.Fill({ color: 'rgba(104, 163, 63, 0.3)' }),
        stroke: new ol.style.Stroke({ color: 'green', width: 1 })
    });
};

const styleFunction1 = feature => {
    return new ol.style.Style({
        fill: new ol.style.Fill({ color: 'rgba(0, 0, 255, 0.3)' }),
        stroke: new ol.style.Stroke({ color: 'green', width: 1 })
    });
};



